module.exports = __webpack_public_path__ + "static/img/far1_active.9df9a36f.png";